import { render, staticRenderFns } from "./SubstanceTableV5.vue?vue&type=template&id=35c96e60&scoped=true&"
import script from "./SubstanceTableV5.vue?vue&type=script&lang=js&"
export * from "./SubstanceTableV5.vue?vue&type=script&lang=js&"
import style0 from "./SubstanceTableV5.vue?vue&type=style&index=0&id=35c96e60&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c96e60",
  null
  
)

export default component.exports